// tracks events specified in DIR2-773 tickets
// not all events are resolved here,
// for more look for 'LogRocket.track'.

KMVP.logRocketService = {
    trackEvent: function(eventName) {
        if (window.LogRocket) {
            LogRocket.track(eventName);
        }
    },
    checkForCurrentEvent: function() {
        // array includes pairs of location fragments and name of log rocket event
        // that needs to be triggered if location fragment matches current href location
        // please update if any change to the paths occurs
        var locAndEventArr = [
            ['/checkout/orderConfirmation/', 'confirmation_submit_buy_cart_viewed_d2'],
            ['/checkout/single/summary', 'checkout_page_viewed_d2'],
            ['/quotes\\?showallforstatus', 'quotes_by_status_viewed_d2'],
            ['/my-account/quotes/details/', 'quote_detail_viewed_d2'],
            ['/my-account/quotes', 'quotes_overview_viewed_d2'],
            ['/quote-cart/confirmation/', 'confirmation_submit_cart_viewed_d2'],
            ['/quote-cart', 'cart_viewed_d2'],
            ['/cart', 'buy_cart_viewed_d2'],
            ['/search/', 'product_listing_viewed_d2']
        ];
        var i = 0;
        while (i < locAndEventArr.length && !window.location.href.match(locAndEventArr[i][0])) {
            i++;
        }
        if (i != locAndEventArr.length) {
            KMVP.logRocketService.trackEvent(locAndEventArr[i][1]);
        }
    }
};

$(document).ready(function() {
    KMVP.logRocketService.checkForCurrentEvent();
});
